import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from 'react';
export var SelectButtonLabel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectButtonLabel, _React$Component);

  function SelectButtonLabel() {
    _classCallCheck(this, SelectButtonLabel);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectButtonLabel).apply(this, arguments));
  }

  _createClass(SelectButtonLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          options = _this$props.options;
      var placeholder = this.props.placeholder || null;

      if (!value) {
        return placeholder || null;
      }

      if (!Array.isArray(value)) {
        var option = options.find(function (option) {
          return option.value === value;
        });
        return option ? option.label : placeholder;
      }

      return options.reduce(function (labels, option) {
        if (value.includes(option.value)) {
          return [].concat(_toConsumableArray(labels), [option.label]);
        }

        return labels;
      }, []).join(', ') || placeholder;
    }
  }]);

  return SelectButtonLabel;
}(React.Component);